import { mapValues } from 'lodash'

export const mapVCP = mappings => {
  return mapValues(mappings, mapper => {
    return componentContext => {
      let config =
        componentContext.$store.getters['vcp/vcpConfig'][
          componentContext.$store.getters['vcp/currentTarget'][1]
        ]
      if (!config) {
        config = componentContext.$store.getters['vcp/vcpConfig'][2] // medium по умолчанию
      }
      let stringMapper = null
      let defaultValue = null
      if (typeof mapper === 'string') {
        stringMapper = mapper
      } else {
        // should be array
        if (!mapper.length || mapper.length < 2) {
          console.error('incorrect mapper', mapper)
        }
        stringMapper = mapper[0]
        defaultValue = mapper[1]
      }
      return config?.[stringMapper] || defaultValue
    }
  })
}
